const hasImage = (image) =>
  image && !image.includes('Product-Placeholder-Default-20210415') ? image : '';

export default hasImage;
